<script lang="ts">
    import { createEventDispatcher } from "svelte"
    import { taskEditors, users } from "../../store"
    import {
        checkIfStepIsBlockedByOtherUser,
        checkIfStepIsCompleted,
        getCurrentBlockingTaskEditor,
        getStepCompletedObject,
    } from "../helper"
    import CalculateSessionStart from "./CalculateSessionStart.svelte"
    const dispatch = createEventDispatcher()
    export function formatDate(date: Date | string): string {
        date = new Date(date)
        const day = date.getDate().toString().padStart(2, "0")
        const month = (date.getMonth() + 1).toString().padStart(2, "0")
        const year = date.getFullYear().toString().slice(-2)
        return `${day}.${month}.${year}`
    }

    export function formatTime(date: Date | string): string {
        date = new Date(date)
        const hours = date.getHours().toString().padStart(2, "0")
        const minutes = date.getMinutes().toString().padStart(2, "0")
        return `${hours}:${minutes}`
    }

    export let stepIndex: number,
        task: TaskOilSpillRemoval | TaskTowing,
        selectedStep: number,
        step: TaskStep,
        showBlocked = false,
        changeStep: (index: number) => void

    //
</script>

<button
    class:completed="{checkIfStepIsCompleted(task, stepIndex + 1)}"
    class:blocked="{!checkIfStepIsCompleted(task, stepIndex + 1) &&
        checkIfStepIsBlockedByOtherUser(stepIndex + 1, $taskEditors)}"
    class="tab {selectedStep === stepIndex ||
    (showBlocked && checkIfStepIsBlockedByOtherUser(stepIndex + 1, $taskEditors))
        ? 'active'
        : ''}"
    on:click="{() => {
        dispatch('stepSelected')
        changeStep(stepIndex)
    }}"
>
    {#if checkIfStepIsCompleted(task, stepIndex + 1) && stepIndex !== selectedStep}
        <span class="completed-circle">
            <img
                src="../../../assets/icons/solar_check-read-outline-white.svg"
                alt="completed"
            />
        </span>
    {:else}
        <span>{stepIndex + 1}</span>
    {/if}
    <div>
        <p>{step.label}</p>
        {#key $users}
            {#if stepIndex == selectedStep && checkIfStepIsCompleted(task, stepIndex + 1)}
                <div class="completed">
                    <img
                        src="../../../assets/icons/solar_check-read-outline-white.svg"
                        alt="completed"
                    />
                    <span class="username border-right">
                        {$users[getStepCompletedObject(task, stepIndex + 1).completedBy]?.username || ""}
                    </span>
                    <span class="date border-right">
                        {formatDate(getStepCompletedObject(task, stepIndex + 1).completedAt)}
                    </span>
                    <span class="time">
                        {formatTime(getStepCompletedObject(task, stepIndex + 1).completedAt)}
                    </span>
                </div>
            {:else if (stepIndex == selectedStep || showBlocked) && checkIfStepIsBlockedByOtherUser(stepIndex + 1, $taskEditors)}
                <div class="blocked">
                    <img
                        src="../../../assets/icons/solar_lock-bold-white.svg"
                        alt="edit"
                    />
                    <span class="username border-right">
                        {$users[getCurrentBlockingTaskEditor(stepIndex + 1, $taskEditors).userId]?.username || ""}
                    </span>
                    <CalculateSessionStart
                        sessionStart="{new Date(
                            getCurrentBlockingTaskEditor(stepIndex + 1, $taskEditors).sessionStart
                        )}"
                    />
                </div>
            {/if}
        {/key}
    </div>
</button>

<style lang="less">
    .tab {
        display: flex;
        height: 60px;
        padding: 0.6rem 1.2rem;
        align-items: center;
        gap: 0.6rem;
        border-radius: 0.6rem 0.6rem 0px 0px;

        & > span {
            border-radius: 1.4rem;
            border: 2px solid var(--white-100);
            width: 1.4rem;
            height: 1.4rem;
            display: flex;
            align-items: center;
            justify-content: center;
            color: var(--white-100);
            background-color: var(--text-100);
            font-weight: 700;
            font-family: Inter-Bold;
            font-size: 0.8rem;
            &.completed-circle {
                background-color: var(--confirm-100);
            }
        }
        & > div {
            display: flex;
            flex-direction: column;
            gap: 6px;

            p {
                color: var(--text-100);
                display: flex;
                justify-content: flex-start;
                font-size: 1.2rem;
            }
            & > div {
                display: flex;
                height: 0.5rem;
                align-items: center;
                & > * {
                    padding-right: 6px;
                    color: white;
                }
                img {
                    height: 0.5rem;
                    object-fit: contain;
                }
            }
        }
        &.active {
            background: var(--text-100);
            & > div {
                p {
                    color: white;
                }
            }

            &.edited {
                background: var(--red-100);
            }
            &.completed {
                background: var(--confirm-100);
            }
            &.blocked {
                background: var(--red-100);
            }
            .border-right {
                border-right: 1px solid white;
                margin-right: 6px;
            }
        }
    }
</style>
